<template>
  <div>
    <div
      style="
        width: 1638px;
        margin: 15px 15px 0 15px;
        padding: 15px;
        background-color: #f3f3f3;
        display: flow-root;
        border: 1px solid #e7e7e7;
        border-radius: 3px;
      "
    >
      <div style="float: left; line-height: 32px; width: 463px; height: 30px; font-size: 15px">
        {{ $t("AdverStatistics.adverzy") }}
      </div>
      <div style="float: right">
        <el-select v-model="searchType" size="small" @change="DataStatistics">
          <el-option :label="$t('AdverStatistics.ggjine')" value="price"></el-option>
          <el-option :label="$t('AdverStatistics.ggcishu')" value="num"></el-option>
        </el-select>
      </div>
    </div>
    <div v-loading="tjloading" style="width: 1670px; padding: 15px; display: flex; align-items: center">
      <el-card style="margin-right: 7.5px">
        <div style="display: flow-root">
          <div v-if="searchType == 'price'" style="width: 100%">
            {{ $t("AdverStatistics.jrggbfje") }}
          </div>
          <div v-else style="width: 100%">
            {{ $t("AdverStatistics.jrggbfcs") }}
          </div>
          <div
            style="
              font-size: 13px;
              color: #909399;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 10px;
            "
          >
            <div>
              <div style="font-size: 28px; text-align: center; color: #409eff; font-weight: bold">
                {{ DataStatisticsInfo["todayPrice"] }}
              </div>
              <div style="display: flex; align-items: center; justify-content: center; width: 100%">
                <span>{{ $t('statistics.AdverStatistics.9398731-0') }}</span>
                <span
                  v-if="DataStatisticsInfo['PricesTongbiFH'] == '+'"
                  class="el-icon-caret-top"
                  style="font-size: 20px; color: #67c23a; margin-left: 15px"
                ></span>
                <span
                  v-else-if="DataStatisticsInfo['PricesTongbiFH'] == '-'"
                  class="el-icon-caret-bottom"
                  style="font-size: 20px; color: #f56c6c; margin-left: 15px"
                ></span>
                <span v-else style="font-size: 12px; margin-left: 15px; margin-right: 3px">{{ $t('statistics.AdverStatistics.9398731-1') }}</span>
                <span style="font-size: 14px">{{ DataStatisticsInfo["PricesTongbi"] }}%</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card style="margin: 0 7.5px">
        <div style="display: flow-root">
          <div v-if="searchType == 'price'" style="width: 100%">
            {{ $t("AdverStatistics.bzggbfje") }}
          </div>
          <div v-else style="width: 100%">
            {{ $t("AdverStatistics.bzggbfcs") }}
          </div>
          <div
            style="
              font-size: 13px;
              color: #909399;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 10px;
            "
          >
            <div>
              <div style="font-size: 28px; text-align: center; color: #409eff; font-weight: bold">
                {{ DataStatisticsInfo["weekPrice"] }}
              </div>
              <div style="display: flex; align-items: center; justify-content: center; width: 100%">
                <span>{{ $t('statistics.AdverStatistics.9398731-2') }}</span>
                <span
                  v-if="DataStatisticsInfo['WeekPricesTongbiFH'] == '+'"
                  class="el-icon-caret-top"
                  style="font-size: 20px; color: #67c23a; margin-left: 15px"
                ></span>
                <span
                  v-else-if="DataStatisticsInfo['WeekPricesTongbiFH'] == '-'"
                  class="el-icon-caret-bottom"
                  style="font-size: 20px; color: #f56c6c; margin-left: 15px"
                ></span>
                <span v-else style="font-size: 12px; margin-left: 15px; margin-right: 3px">{{ $t('statistics.AdverStatistics.9398731-1') }}</span>
                <span style="font-size: 14px">{{ DataStatisticsInfo["WeekPricesTongbi"] }}%</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card style="margin: 0 7.5px">
        <div style="display: flow-root">
          <div v-if="searchType == 'price'" style="width: 100%">
            {{ $t("AdverStatistics.byggbfje") }}
          </div>
          <div v-else style="width: 100%">
            {{ $t("AdverStatistics.byggbfcs") }}
          </div>
          <div
            style="
              font-size: 13px;
              color: #909399;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 10px;
            "
          >
            <div>
              <div style="font-size: 28px; text-align: center; color: #409eff; font-weight: bold">
                {{ DataStatisticsInfo["monthPrice"] }}
              </div>
              <div style="display: flex; align-items: center; justify-content: center; width: 100%">
                <span>{{ $t('statistics.AdverStatistics.9398731-2') }}</span>
                <span
                  v-if="DataStatisticsInfo['MonthPricesTongbiFH'] == '+'"
                  class="el-icon-caret-top"
                  style="font-size: 20px; color: #67c23a; margin-left: 15px"
                ></span>
                <span
                  v-else-if="DataStatisticsInfo['MonthPricesTongbiFH'] == '-'"
                  class="el-icon-caret-bottom"
                  style="font-size: 20px; color: #f56c6c; margin-left: 15px"
                ></span>
                <span v-else style="font-size: 12px; margin-left: 15px; margin-right: 3px">{{ $t('statistics.AdverStatistics.9398731-1') }}</span>
                <span style="font-size: 14px">{{ DataStatisticsInfo["MonthPricesTongbi"] }}%</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card style="margin-left: 7.5px">
        <div style="display: flow-root">
          <div v-if="searchType == 'price'" style="width: 100%">
            {{ $t("AdverStatistics.zggbfje") }}
          </div>
          <div v-else style="width: 100%">
            {{ $t("AdverStatistics.zggbfcs") }}
          </div>
          <div
            style="
              font-size: 13px;
              color: #909399;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 10px;
            "
          >
            <div>
              <div style="font-size: 28px; text-align: center; color: #409eff; font-weight: bold">
                {{ DataStatisticsInfo["price"] }}
              </div>
              <div style="display: flex; align-items: center; justify-content: center; width: 100%; color: white">
                <span>{{ $t('statistics.AdverStatistics.9398731-2') }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div
      style="
        width: 1638px;
        margin: 0 15px 15px 15px;
        padding: 15px;
        background-color: #f3f3f3;
        display: flow-root;
        border: 1px solid #e7e7e7;
        border-radius: 3px;
      "
    >
      <div class="el-left" style="line-height: 32px; width: 463px; height: 30px; font-size: 15px">
        {{ $t("AdverStatistics.guanggaotj") }}
      </div>
      <div class="el-right" style="width: 988px">
        <div style="width: 100%; display: flow-root">
          <el-select
            v-model="search.dayType"
            @change="handlerDayTypeChange"
            size="small"
            style="width: 170px; margin-right: 15px"
          >
            <!-- <el-option :label="$t('AdverStatistics.anniantj')" value="1"></el-option> -->
            <el-option :label="$t('AdverStatistics.anyuetj')" value="2"></el-option>
            <el-option :label="$t('AdverStatistics.anritj')" value="3"></el-option>
          </el-select>
          <el-date-picker
            v-model="dateTime"
            size="small"
            :clearable="false"
            :type="search.dayType == '1' ? 'yearange' : search.dayType == '2' ? 'monthrange' : 'daterange'"
            :format="search.dayType == '1' ? 'yyyy' : search.dayType == '2' ? 'yyyy-MM' : 'yyyy-MM-dd'"
            :value-format="search.dayType == '1' ? 'yyyy' : search.dayType == '2' ? 'yyyy-MM' : 'yyyy-MM-dd'"
            range-separator="-"
            :start-placeholder="$t('searchMachineProfit.start')"
            :end-placeholder="$t('searchMachineProfit.end')"
            style="width: 335px; margin-right: 15px"
          ></el-date-picker>
          <el-select
            v-model="search.equipmentNos"
            size="small"
            filterable
            :placeholder="$t('MachineProfit.qbjiqi')"
            multiple
            remote
            :loading="machineLoading"
            :remote-method="handlerGetAllMachine"
            style="width: 260px; margin-right: 15px"
          >
            <el-option
              v-for="item in allMachine"
              :key="item.id"
              :value="item.equipmentNo"
              :label="item.equipmentName"
            />
          </el-select>
          <el-button type="primary" @click="DayStatisticsData" size="small" icon="el-icon-search">{{
            $t("common.search")
          }}</el-button>
          <el-button @click="handlerResetSearch" size="small" icon="el-icon-refresh">{{
            $t("common.reset")
          }}</el-button>
        </div>
      </div>
    </div>
    <div style="width: 1670px; padding: 15px; display: flow-root">
      <div id="rytjchart"></div>
    </div>
    <div
      style="
        width: 1638px;
        margin: 0 15px 15px 15px;
        padding: 15px;
        background-color: #f3f3f3;
        display: flow-root;
        border: 1px solid #e7e7e7;
        border-radius: 3px;
      "
    >
      <div class="el-left" style="line-height: 32px; height: 30px; font-size: 15px">
        <el-button
          type="primary"
          @click="ExportMachineData"
          size="small"
          icon="el-icon-download"
          style="margin-right: 15px"
          >{{ $t("common.export") }}</el-button
        >
      </div>
      <div class="el-right">
        <div style="width: 100%; display: flow-root">
          <el-date-picker
            v-model="tableDateTime"
            size="small"
            :clearable="true"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            label-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            :start-placeholder="$t('AdverStatistics.start')"
            :end-placeholder="$t('AdverStatistics.end')"
            style="width: 335px; margin-right: 15px"
          ></el-date-picker>
          <el-input
            v-model="tableSearch.userName"
            size="small"
            :placeholder="$t('AdverStatistics.userName')"
            style="width: 200px; margin-right: 15px"
          ></el-input>
          <el-input
            v-model="tableSearch.equipmentNo"
            size="small"
            :placeholder="$t('AdverStatistics.equipmentNo')"
            style="width: 200px; margin-right: 15px"
          ></el-input>
          <el-input
            v-model="tableSearch.head"
            size="small"
            :placeholder="$t('AdverStatistics.title')"
            style="width: 200px; margin-right: 15px"
          ></el-input>
          <el-input
            v-model="tableSearch.advertiser"
            size="small"
            :placeholder="$t('AdverStatistics.advertiser')"
            style="width: 200px; margin-right: 15px"
          ></el-input>
          <el-button type="primary" @click="handlerSubmitTableSearch" size="small" icon="el-icon-search">{{
            $t("common.search")
          }}</el-button>
          <el-button @click="handlerResetTableSearch" size="small" icon="el-icon-refresh">{{
            $t("common.reset")
          }}</el-button>
        </div>
      </div>
    </div>
    <div class="vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="dateProfitList"
        style="width: 100%"
        max-height="638"
        :border="true"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          prop="username"
          :show-overflow-tooltip="true"
          :label="$t('AdverStatistics.userName')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentNo"
          :label="$t('AdverStatistics.equipmentNo')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentName"
          :label="$t('AdverStatistics.equipmentName')"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="head" :label="$t('AdverStatistics.title')" :align="'center'"></el-table-column>
        <el-table-column
          prop="advertiser"
          :label="$t('AdverStatistics.advertiser')"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="num" :label="$t('AdverStatistics.record')" :align="'center'"> </el-table-column>
      </el-table>
      <el-pagination
        v-if="page.totalSize > 0"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="CurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import * as echarts from "echarts";
  let rytjchart = null;
  export default {
    name: "DateProfit",
    data() {
      return {
        tjloading: false,
        searchType: "price",
        DataStatisticsInfo: {},
        dateProfitList: [],
        search: {
          dayType: "2",
          startTime: "",
          endTime: "",
          equipmentNos: ""
        },
        dateTime: [],
        //  Table数据
        loading: false,
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        tableSearch: {
          startTime: "",
          endTime: "",
          advertiser: "",
          userName: "",
          head: "",
          equipmentNo: ""
        },
        tableDateTime: [],
        //  树形Tree联合select使用
        Mloading: false,
        FullMachine: "",
        MachinesValue: [],
        DefaultProps: {
          children: "children",
          label: "name",
          isLeaf: "leaf"
        },
        allMachine: [],
        machineLoading: false
      };
    },
    mounted() {
      let _self = this;
      _self.handlerGiveDefaultTime();
      _self.DataStatistics();
      _self.handlerDayTypeChange(_self.search.dayType);
      rytjchart = echarts.init(document.getElementById("rytjchart"), null, {
        width: 1670,
        height: 400
      });
      _self.DayStatisticsData();
      _self.CurrentChange();
    },
    methods: {
      handlerGetAllMachine(query) {
        if (query === "") return;
        this.machineLoading = true;
        this.$api
          .request(this.$url.UserMachine.listUserMachineSelect, this.$method.get, { searchName: query })
          .then(res => {
            this.allMachine = res.data.records;
            this.machineLoading = false;
          });
      },
      //  动态加载TREE框数据
      loadMachineTreeNode(node, resolve) {
        let _self = this;
        if (node.level === 0) {
          _self.Mloading = true;
          //  加载一级节点（机器分组）
          _self.$api
            .request(_self.$url.UserMachineGroup.list, _self.$method.get, {})
            .then(res => {
              _self.Mloading = false;
              if (res.code === 0) {
                let reslist = res.data;
                let listset = [];
                for (let i = 0; i < reslist.length; i++) {
                  let id = reslist[i]["id"];
                  let name = reslist[i]["name"];
                  listset.push({
                    id: id,
                    name: name,
                    disabled: true,
                    parent: true
                  });
                }
                return resolve(listset);
              } else {
                return resolve([]);
              }
            })
            .catch(() => {
              return resolve([]);
            });
        }
        if (node.level > 1) return resolve([]);
        if (node.level == 1) {
          //  加载二级节点（机器分组下的机器）
          _self.$api
            .request(_self.$url.UserMachine.listUserMachineByGroupId, _self.$method.get, {
              teamId: node.data.id
            })
            .then(res => {
              if (res.code === 0) {
                let reslist = res.data;
                let listset = [];
                for (let i = 0; i < reslist.length; i++) {
                  let equipmentNo = reslist[i]["equipmentNo"];
                  let equipmentName = reslist[i]["equipmentName"];
                  listset.push({
                    id: equipmentNo,
                    name: equipmentName,
                    parent: false,
                    leaf: true
                  });
                }
                resolve(listset);
                //  有子节点才可选
                let childNodes = node.childNodes;
                if (childNodes.length > 0) {
                  node.data.disabled = false;
                }
              } else {
                resolve([]);
              }
            })
            .catch(() => {
              resolve([]);
            });
        }
      },
      //  SELECT框搜索值触发的事件（搜索）
      hanlderMachineSelectFilter(val) {
        let _self = this;
        //  过滤Tree的数据
        _self.$refs.MachineTree.filter(val);
      },
      //  SELECT框下拉框出现/隐藏时触发（显示/隐藏）
      //  出现则为 true，隐藏则为 false
      handlerMachineSelectVisibleChange(boolean) {
        let _self = this;
        if (!boolean) {
          //  隐藏则需要恢复Tree原来数据
          _self.$refs.MachineTree.filter("");
        }
      },
      //  SELECT框值改变触发的事件（删除，需要同步删除MachineTree的选项）
      handlerMachineSelectChange(e) {
        let _self = this;
        var arrNew = [];
        var dataLength = _self.MachinesValue.length;
        var eleng = e.length;
        for (let i = 0; i < dataLength; i++) {
          for (let j = 0; j < eleng; j++) {
            if (e[j] === _self.MachinesValue[i].name) {
              arrNew.push(_self.MachinesValue[i]);
            }
          }
        }
        //  设置勾选的值
        _self.$refs.MachineTree.setCheckedNodes(arrNew);
      },
      //  TREE框的自定义过滤方法
      //  执行_self.$refs.MachineTree.filter();触发
      filterMachineTreeDate(value, data) {
        if (!value) {
          return true;
        } else {
          return data.name.indexOf(value) !== -1;
        }
      },
      //  TREE框节点被点击(单选需要使用到)
      handleMachineNodeClick() {
        //  let _self = this;
        //  使 input 失去焦点，并隐藏下拉框
        //  _self.$refs.MachineSelectTree.blur();.
      },
      //  TREE值改变时候触发的事件
      handleMachineCheckChange() {
        let _self = this;
        let res = _self.$refs.MachineTree.getCheckedNodes(true, true);
        //  这里两个true
        //  1. 是否只是叶子节点
        //  2. 是否包含半选节点（就是使得选择的时候不包含父节点）
        let arrName = [];
        let arr = [];
        res.forEach(item => {
          if (!item.parent) {
            arrName.push(item.name);
            arr.push(item);
          }
        });
        _self.MachinesValue = arr;
        _self.FullMachine = arrName;
      },
      //  搜索类型查询
      handlerDayTypeChange(value) {
        let _self = this;
        if (parseInt(value) == 1) {
        } else if (parseInt(value) == 2) {
          let myDate = new Date();
          //  当前时间年月日时分秒
          let year = myDate.getFullYear();
          let month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          let day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          let hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          let minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          let second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          let endTimetime = year + "-" + month;
          //  30天前的时间
          let ddstian = 365;
          myDate.setTime(myDate.getTime() - 24 * ddstian * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          //  获取统计数据
          let startTimetime = year + "-" + month;
          _self.dateTime = [startTimetime, endTimetime];
        } else if (parseInt(value) == 3) {
          let myDate = new Date();
          //  当前时间年月日时分秒
          let year = myDate.getFullYear();
          let month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          let day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          let hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          let minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          let second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          let endTimetime = year + "-" + month + "-" + day;
          //  30天前的时间
          let ddstian = 31;
          myDate.setTime(myDate.getTime() - 24 * ddstian * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          //  获取统计数据
          let startTimetime = year + "-" + month + "-" + day;
          _self.dateTime = [startTimetime, endTimetime];
        }
      },
      // 首字母大写
      capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      },
      //  获取数据统计
      DataStatistics() {
        let _self = this;
        _self.tjloading = true;
        _self.$api
          .request(_self.$url.AdverStatistics.advert, _self.$method.get, {})
          .then(res => {
            _self.tjloading = false;
            if (res.code === 0) {
              console.log(res.data, 111);
              const locale = "en-US"; // zh-CN
              const options = { style: "currency", currency: "USD" }; // CNY
              //  总广告播放金额
              let num = parseInt(res.data.num);
              let formattedPrice = num.toLocaleString();
              if (_self.searchType == "price") {
                const price = parseFloat(res.data.price);
                formattedPrice = new Intl.NumberFormat(locale, options).format(price);
              }
              res.data.price = formattedPrice;
              //  今日广告播放金额
              const todayPrice = parseFloat(res.data["today" + _self.capitalizeFirstLetter(_self.searchType)]);
              let todayPrices = parseFloat(res.data["today" + _self.capitalizeFirstLetter(_self.searchType)]);
              let yesterdayPrices = parseFloat(res.data["yesterday" + _self.capitalizeFirstLetter(_self.searchType)]);
              let formattedTodayPrice = todayPrice.toLocaleString();
              if (_self.searchType == "price") {
                formattedTodayPrice = new Intl.NumberFormat(locale, options).format(todayPrice);
              }
              res.data.todayPrice = formattedTodayPrice;
              //  今日广告播放金额 同比增长或减少
              let PricesTongbi = 0;
              if (yesterdayPrices > 0) {
                PricesTongbi = (todayPrices - yesterdayPrices) / yesterdayPrices;
              } else {
                PricesTongbi = todayPrices * 0.01;
              }
              PricesTongbi = PricesTongbi * 100;
              res.data.PricesTongbi = PricesTongbi.toFixed(2);
              if (PricesTongbi < 0) {
                res.data.PricesTongbiFH = "-";
                res.data.PricesTongbi = Math.abs(res.data.PricesTongbi);
              } else if (PricesTongbi > 0) {
                res.data.PricesTongbiFH = "+";
              } else {
                res.data.PricesTongbiFH = "";
              }
              //  本周广告播放金额
              const weekPrice = parseFloat(res.data["week" + _self.capitalizeFirstLetter(_self.searchType)]);
              let weekPrices = parseFloat(res.data["week" + _self.capitalizeFirstLetter(_self.searchType)]);
              let lastWeekPrices = parseFloat(res.data["lastWeek" + _self.capitalizeFirstLetter(_self.searchType)]);
              let formattedWeekPrice = weekPrice.toLocaleString();
              if (_self.searchType == "price") {
                formattedWeekPrice = new Intl.NumberFormat(locale, options).format(weekPrice);
              }
              res.data.weekPrice = formattedWeekPrice;
              //  本周广告播放金额 同比增长或减少
              let WeekPricesTongbi = 0;
              if (lastWeekPrices > 0) {
                WeekPricesTongbi = (weekPrices - lastWeekPrices) / lastWeekPrices;
              } else {
                WeekPricesTongbi = weekPrices * 0.01;
              }
              WeekPricesTongbi = WeekPricesTongbi * 100;
              res.data.WeekPricesTongbi = WeekPricesTongbi.toFixed(2);
              if (WeekPricesTongbi < 0) {
                res.data.WeekPricesTongbiFH = "-";
                res.data.WeekPricesTongbi = Math.abs(res.data.WeekPricesTongbi);
              } else if (WeekPricesTongbi > 0) {
                res.data.WeekPricesTongbiFH = "+";
              } else {
                res.data.WeekPricesTongbiFH = "";
              }
              //  本月广告播放金额
              const monthPrice = parseFloat(res.data["month" + _self.capitalizeFirstLetter(_self.searchType)]);
              let monthPrices = parseFloat(res.data["month" + _self.capitalizeFirstLetter(_self.searchType)]);
              let lastMonthPrices = parseFloat(res.data["lastMonth" + _self.capitalizeFirstLetter(_self.searchType)]);
              let formattedMonthPrice = monthPrice.toLocaleString();
              if (_self.searchType == "price") {
                formattedMonthPrice = new Intl.NumberFormat(locale, options).format(monthPrice);
              }
              res.data.monthPrice = formattedMonthPrice;
              //  本月广告播放金额 同比增长或减少
              let MonthPricesTongbi = 0;
              if (lastMonthPrices > 0) {
                MonthPricesTongbi = (monthPrices - lastMonthPrices) / lastMonthPrices;
              } else {
                MonthPricesTongbi = monthPrices * 0.01;
              }
              MonthPricesTongbi = MonthPricesTongbi * 100;
              res.data.MonthPricesTongbi = MonthPricesTongbi.toFixed(2);
              if (MonthPricesTongbi < 0) {
                res.data.MonthPricesTongbiFH = "-";
                res.data.MonthPricesTongbi = Math.abs(res.data.MonthPricesTongbi);
              } else if (MonthPricesTongbi > 0) {
                res.data.MonthPricesTongbiFH = "+";
              } else {
                res.data.MonthPricesTongbiFH = "";
              }
              _self.DataStatisticsInfo = res.data;
            }
            _self.handlerSubmitSearch();
          })
          .catch(() => {
            _self.tjloading = false;
          });
      },
      //  日期统计数据
      DayStatisticsData() {
        let _self = this;
        let params = {
          type: parseInt(_self.search.dayType),
          searchType: _self.searchType.toLowerCase()
        };
        if (_self.dateTime && _self.dateTime.length > 0) {
          params.startDate = _self.dateTime[0];
          params.endDate = _self.dateTime[1];
        }
        if (_self.search.equipmentNos.length > 0) {
          params.equipmentNos = _self.search.equipmentNos.join(",");
        }
        rytjchart.showLoading();
        _self.$api
          .request(_self.$url.AdverStatistics.day, _self.$method.get, params)
          .then(res => {
            let result = res.data;
            let xAxisData = [];
            let seriesData = [];
            for (let i = 0; i < result.length; i++) {
              let statDate = result[i]["statDate"];
              xAxisData.push(statDate);
              seriesData.push(result[i][_self.searchType == "price" ? "price" : "num"]);
            }
            let rytjoption = {
              tooltip: {
                trigger: "axis"
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: xAxisData
              },
              yAxis: {
                type: "value"
              },
              series: [
                {
                  name:
                    _self.searchType == "price"
                      ? _self.$t("AdverStatistics.ggjine")
                      : _self.$t("AdverStatistics.ggcishu"),
                  data: seriesData,
                  type: "line",
                  areaStyle: {}
                }
              ]
            };
            rytjchart.clear();
            rytjoption && rytjchart.setOption(rytjoption);
            rytjchart.hideLoading();
          })
          .catch(() => {
            rytjchart.hideLoading();
          });
      },
      //  重置搜索
      handlerResetSearch(type) {
        let _self = this;
        _self.search.dayType = "2";
        _self.handlerDayTypeChange(_self.search.dayType);
        _self.FullMachine = "";
        _self.search.equipmentNos = [];
        _self.search.searchType = "totalNum";
        _self.MachinesValue = [];
        _self.DayStatisticsData();
        _self.CurrentChange();
      },
      //  提交搜索
      handlerSubmitTableSearch() {
        let _self = this;
        _self.CurrentChange();
      },
      //  重置搜索
      handlerResetTableSearch(type) {
        let _self = this;
        this.tableSearch.advertiser = "";
        this.tableSearch.userName = "";
        this.tableSearch.head = "";
        this.tableSearch.equipmentNo = "";
        this.handlerGiveDefaultTime();
        _self.CurrentChange();
      },
      formatDateTime(date) {
        let year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, "0");
        let day = date.getDate().toString().padStart(2, "0");
        let hours = date.getHours().toString().padStart(2, "0");
        let minutes = date.getMinutes().toString().padStart(2, "0");
        let seconds = date.getSeconds().toString().padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      //  数据表
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      CurrentChange(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = _self.$cloud.objMerge(_self.tableSearch, _self.page);
        if (_self.tableDateTime && _self.tableDateTime.length > 0) {
          obj.startTime = _self.tableDateTime[0];
          obj.endTime = _self.tableDateTime[1];
        }
        _self.$api
          .request(_self.$url.AdverStatistics.advertRecord, _self.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              _self.dateProfitList = res.data.records;
              _self.order = res.data.sum;
              _self.page.totalSize = parseInt(res.data.total);
            }
            _self.loading = false;
          })
          .catch(() => {
            _self.loading = false;
          });
      },
      // 指定列求和
      getSummaries(param) {
        const { columns, data } = param;
        const sums = ["", "", "", "", "", ""];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = <span style="font-weight: bold;">{this.$t("machineRenewal.total")}</span>;
            return;
          }
          console.log(column, 11);
          if (!(column.property == "price" || column.property == "num")) return "";
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += "";
          } else {
            sums[index] = "N/A";
          }
        });
        return sums;
      },
      // 导出
      ExportMachineData() {
        let _self = this;
        let obj = _self.$cloud.objMerge(_self.tableSearch, _self.page);
        if (_self.tableDateTime && _self.tableDateTime.length > 0) {
          obj.startTime = _self.tableDateTime[0];
          obj.endTime = _self.tableDateTime[1];
        }

        _self.$api.download(_self.$url.AdverStatistics.export, obj);
      },
      handlerGiveDefaultTime() {
        let myDate = new Date();
        //  当前时间年月日时分秒
        let year = myDate.getFullYear();
        let month = myDate.getMonth() + 1;
        if (parseInt(month) < 10) {
          month = "0" + month;
        }
        let day = myDate.getDate();
        if (parseInt(day) < 10) {
          day = "0" + day;
        }
        let hour = myDate.getHours();
        if (parseInt(hour) < 10) {
          hour = "0" + hour;
        }
        let minute = myDate.getMinutes();
        if (parseInt(minute) < 10) {
          minute = "0" + minute;
        }
        let second = myDate.getSeconds();
        if (parseInt(second) < 10) {
          second = "0" + second;
        }
        let endTimetime = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
        //  30天前的时间
        let ddstian = 365;
        myDate.setTime(myDate.getTime() - 24 * ddstian * 60 * 60 * 1000);
        year = myDate.getFullYear();
        month = myDate.getMonth() + 1;
        if (parseInt(month) < 10) {
          month = "0" + month;
        }
        day = myDate.getDate();
        if (parseInt(day) < 10) {
          day = "0" + day;
        }
        hour = myDate.getHours();
        if (parseInt(hour) < 10) {
          hour = "0" + hour;
        }
        minute = myDate.getMinutes();
        if (parseInt(minute) < 10) {
          minute = "0" + minute;
        }
        second = myDate.getSeconds();
        if (parseInt(second) < 10) {
          second = "0" + second;
        }
        //  获取统计数据
        let startTimetime = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
        this.tableDateTime = [startTimetime, endTimetime];
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep .el-card {
    width: 417.5px;
    display: flex;
    float: left;
  }
  ::v-deep .el-card__body {
    width: 417.5px;
  }
</style>
